module.exports = __webpack_public_path__ + "static/media/appointment.4c9ce79c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/appointment.svg
// module id = 105
// module chunks = 0